import { Loading } from "app/common/main/pages/Loading";
import { useSetAuthToken } from "shared/hooks/useSetAuthentication";

export const LoggedIn = () => {
  useSetAuthToken();
  return <Loading />;
};
